module.exports = __webpack_public_path__ + "img/fechar-icon-verde.1f15cc8e.svg";